import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class AuthService {

  private tokenKey = 'token';
  private pid = 'pid';
  private uID = 'uID'
  private uName = 'uName';
  private providerTypeId = 'providerTypeId';
  private permissionsKey = 'providerTypeActionPermissions';
  private sidebarMenuData = 'menu'
  private skippedVerificationsKey = 'skippedOtpVerifications';
  constructor(private router: Router) { }

  public isAuthenticated(): boolean {
    return !!localStorage.getItem(this.tokenKey) || !!sessionStorage.getItem(this.tokenKey);
  }

  public setToken(token: string, rememberMe: boolean): void {
    // A fresh login always starts with a clean slate of skipped verifications.
    localStorage.removeItem(this.skippedVerificationsKey);
    rememberMe === true ? localStorage.setItem(this.tokenKey, token) : sessionStorage.setItem(this.tokenKey, token);
  }

  private getSkippedVerifications(): string[] {
    const stored = localStorage.getItem(this.skippedVerificationsKey);
    return stored ? JSON.parse(stored) : [];
  }

  public addSkippedVerification(assuredId: string | number): void {
    if (assuredId === null || assuredId === undefined || assuredId === '') {
      return;
    }
    const skipped = this.getSkippedVerifications();
    const id = String(assuredId);
    if (!skipped.includes(id)) {
      skipped.push(id);
      localStorage.setItem(this.skippedVerificationsKey, JSON.stringify(skipped));
    }
  }

  public isVerificationSkipped(assuredId: string | number): boolean {
    if (assuredId === null || assuredId === undefined || assuredId === '') {
      return false;
    }
    return this.getSkippedVerifications().includes(String(assuredId));
  }

  public getToken(): string | null {
    return localStorage.getItem(this.tokenKey) || sessionStorage.getItem(this.tokenKey);;
  }

  public getCurrentUserPID(): string | null {
    return localStorage.getItem(this.pid);
  }

  public setCurrentUserPID(pid: string): void {
    localStorage.setItem(this.pid, pid);
  }

  public setUserName(uName: string): void {
    localStorage.setItem(this.uName, uName);
  }

  public setUserID(uID: string): void {
    localStorage.setItem(this.uID, uID);
  }
  public getUserID(): string | null {
    return localStorage.getItem(this.uID);
  }
  public getUserName(): string | null {
    return localStorage.getItem(this.uName);
  }

  public setProviderTypeId(providerTypeId: number[]): void {
    localStorage.setItem(this.providerTypeId, JSON.stringify(providerTypeId));
  }

  // public getProviderTypeId(): number[] {
  //   const storedData = localStorage.getItem(this.providerTypeId);
  //   return storedData ? JSON.parse(storedData) : [];
  // }

 public getProviderTypeId(): number[] {
  const storedData = localStorage.getItem("providerTypeId"); // <- use string key
  return storedData ? JSON.parse(storedData) : [];
}


  public setPermissions(permissions: any[]): void {
    localStorage.setItem(this.permissionsKey, JSON.stringify(permissions));
  }

  public getPermissions(): any[] {
    const storedPermissions = localStorage.getItem(this.permissionsKey);
    return storedPermissions ? JSON.parse(storedPermissions) : [];
  }

  public setSidebarMenu(sidebarMenu: any[]): void {
    localStorage.setItem(this.sidebarMenuData, JSON.stringify(sidebarMenu));
  }

  public getSidebarMenu(): any[] {
    const storedMenu = localStorage.getItem(this.sidebarMenuData);
    return storedMenu ? JSON.parse(storedMenu) : [];
  }

  public logout(): void {
    localStorage.removeItem(this.tokenKey);
    localStorage.removeItem(this.pid);
    localStorage.removeItem(this.providerTypeId);
    localStorage.removeItem(this.uName);
    localStorage.removeItem(this.permissionsKey);
    localStorage.removeItem(this.sidebarMenuData);
    localStorage.removeItem(this.skippedVerificationsKey);
    sessionStorage.removeItem(this.tokenKey)
    this.router.navigate(['/']);
  }
}
